<template>
  <Scatter :data="chartData" :options="chartOptions" :plugins="[quadrantPlugin]" />
</template>

<script>
import { Scatter } from 'vue-chartjs'
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js'

ChartJS.register(LinearScale, PointElement, Tooltip)

function makeQuadrantPlugin(labels, midpoint) {
  return {
    id: 'communicationQuadrant',
    afterDraw(chart) {
      const { ctx, chartArea: { left, right, top, bottom }, scales: { x, y } } = chart

      const cx = x.getPixelForValue(midpoint)
      const cy = y.getPixelForValue(midpoint)

      ctx.save()

      ctx.strokeStyle = 'rgba(0,0,0,0.18)'
      ctx.lineWidth   = 1
      ctx.setLineDash([5, 5])
      ctx.beginPath(); ctx.moveTo(cx, top);  ctx.lineTo(cx, bottom); ctx.stroke()
      ctx.beginPath(); ctx.moveTo(left, cy); ctx.lineTo(right, cy);  ctx.stroke()
      ctx.setLineDash([])

      ctx.font         = '11px sans-serif'
      ctx.fillStyle    = 'rgba(0,0,0,0.45)'
      ctx.textAlign    = 'center'
      ctx.textBaseline = 'middle'

      const midLeft  = (left  + cx) / 2
      const midRight = (cx + right) / 2
      const midTop   = (top  + cy)  / 2
      const midBot   = (cy + bottom) / 2

      // labels: { topLeft, topRight, bottomLeft, bottomRight }
      ctx.fillText(labels.bottomLeft,  midLeft,  midBot)
      ctx.fillText(labels.topLeft,     midLeft,  midTop)
      ctx.fillText(labels.bottomRight, midRight, midBot)
      ctx.fillText(labels.topRight,    midRight, midTop)

      ctx.restore()
    },
  }
}

export default {
  name: 'CommunicationQuadrant',
  components: { Scatter },

  props: {
    // X and Y scores, each 1–5
    x: { type: Number, required: true },
    y: { type: Number, required: true },

    // Axis titles
    xLabel: { type: String, required: true },
    yLabel: { type: String, required: true },

    // Quadrant corner labels
    quadrants: {
      type: Object,
      required: true,
      // { topLeft, topRight, bottomLeft, bottomRight }
    },

    // Value at which the crosshair is drawn (default: visual midpoint of 1–5 scale)
    midpoint: { type: Number, default: 3 },
  },

  computed: {
    quadrantPlugin() {
      return makeQuadrantPlugin(this.quadrants, this.midpoint)
    },

    chartData() {
      return {
        datasets: [{
          data: [{ x: this.x, y: this.y }],
          backgroundColor: 'rgba(25, 118, 210, 0.85)',
          pointRadius:      9,
          pointHoverRadius: 11,
          clip:             false,
        }],
      }
    },

    chartOptions() {
      return {
        responsive:          true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: ctx => `${this.xLabel}: ${ctx.parsed.x.toFixed(1)}  ·  ${this.yLabel}: ${ctx.parsed.y.toFixed(1)}`,
            },
          },
        },
        scales: {
          x: {
            title: { display: true, text: this.xLabel, font: { size: 13 }, color: 'rgba(0,0,0,0.65)' },
            min: 1, max: 5,
            ticks: { stepSize: 1 },
            grid:   { color: ctx => ctx.tick.value === this.midpoint ? 'transparent' : 'rgba(0,0,0,0.06)' },
            border: { color: 'rgba(0,0,0,0.45)', width: 2 },
          },
          y: {
            title: { display: true, text: this.yLabel, font: { size: 13 }, color: 'rgba(0,0,0,0.65)' },
            min: 1, max: 5,
            ticks: { stepSize: 1 },
            grid:   { color: ctx => ctx.tick.value === this.midpoint ? 'transparent' : 'rgba(0,0,0,0.06)' },
            border: { color: 'rgba(0,0,0,0.45)', width: 2 },
          },
        },
      }
    },
  },
}
</script>
